import React, { useContext } from 'react';
import { Field } from 'react-final-form';
import { LocaleContext, UploadField } from 'shared';
import { UploadFieldProps } from 'shared/uploadField/UploadField.types';
import { CertificateType } from 'store/api/types';
import { required } from 'utils/formValidators';

import { AddCertificateFieldProps } from './AddCertificateField.types';
const formatFile = (value?: any) => {
  try {
    return value ? [btoa(value)] : [];
  } catch (error) {
    return [];
  }
};

const parseFile = (value?: any) => {
  try {
    return value && value[0] ? value[0].split(',')[1] : '';
  } catch (error) {
    return '';
  }
};

export const AddCertificateField = ({ certificateType, setFileName }: AddCertificateFieldProps) => {
  const localeContext = useContext(LocaleContext);
  const allowedExtensions = ['application/x-pem-file', 'application/x-x509-user-cert'];

  return (
    <Field
      name={`${certificateType}Certificate`}
      validate={required(localeContext.formatMessage({ id: 'FORM.REQUIRED' }))}
      format={formatFile}
      parse={parseFile}
    >
      {({ input, meta }: UploadFieldProps) => (
        <UploadField
          label={localeContext.formatMessage({
            id:
              CertificateType.QSEALC === certificateType ? 'FORM.CERTIFICATIONS-SIGNATURE' : 'FORM.CERTIFICATIONS-TLS',
          })}
          input={input}
          onFileNameChange={setFileName}
          meta={meta}
          className={`application-form__certifications-${certificateType}`}
          multiple={false}
          maxFilesize={10 ** 7}
          maxCount={1}
          allowedExtensions={allowedExtensions}
        />
      )}
    </Field>
  );
};
